import { render, staticRenderFns } from "./StoreManageTable.vue?vue&type=template&id=8cf83a7a&scoped=true"
import script from "./StoreManageTable.vue?vue&type=script&lang=js"
export * from "./StoreManageTable.vue?vue&type=script&lang=js"
import style0 from "./StoreManageTable.vue?vue&type=style&index=0&id=8cf83a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf83a7a",
  null
  
)

export default component.exports